export default "__VITE_ASSET__PLZF9jRJ__"